import styled from 'styled-components';

export const Table = styled.table`
    min-width: ${props => props.width || 'unset'};

    td {
        font-weight: 400;
        font-size: 15px;
        line-height: 18.29px;
        padding-bottom: 30px;
    }
`;